import React from 'react';
import styled, { keyframes } from 'styled-components';
import { FaSpinner } from 'react-icons/fa';

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div<any>`
  /* TODO: Fix types */
  display: flex;
  flex-direction: ${props => props.layout};
  align-self: auto;
  align-items: center;
`;

const SpinnerContainer = styled.div<any>`
  /* TODO: Fix types */
  height: ${props => props.size};
  width: ${props => props.size};
  animation: ${rotate} 1.2s linear infinite;
  margin-right: 5px;
  justify-content: center;
`;

export const Spinner: React.FC<{
  color?: string;
  fontSize?: string;
  layout?: 'row' | 'column';
}> = ({ color, fontSize, layout = 'row' }) => (
  <SpinnerWrapper layout={layout}>
    <SpinnerContainer size={fontSize ?? '20px'}>
      <FaSpinner color={color ?? '#b5121b'} fontSize={fontSize ?? '20px'} />
    </SpinnerContainer>
  </SpinnerWrapper>
);
